import { StudyDeploymentConfig } from "./study.config";

export const ENV = {
  // REACT_APP_BASE_URL: 'http://localhost:4000',
  REACT_APP_BASE_URL: 'https://kastafioreapi.mentalplus.fr',
  REACT_APP_BASE_URL_MOCK: 'https://ebc36566-93e2-4300-b2ec-9a353debbbe7.mock.pstmn.io',
  VAPID_PUBLIC_KEY: "BP6xaq0wOLB8w368ESw6jWyjKZD7Us5TgtjNdt3_ezpZXhH2DLhOpuXkh3KDnPNn-JavIbbU7HslBopce-XObDw",
  // Single-study deployment: study id/slug/is_gamified are known up front, so the app
  // skips the slug -> id welcome lookup and the is_gamified call at bootstrap.
  // For a multi-study deployment use: { mode: 'multi', id: null, slug: null, is_gamified: null }
  STUDY: {
    mode: 'single',
    id: 1,
    slug: 'mentalplus',
    is_gamified: false,
  } as StudyDeploymentConfig,
}
